import { css } from 'styled-components'

export default css`
  .BaseModal-Content.popup {
    width: 520px;
  }

  &.VerifyPhoneModal .BaseModal-Body {
    position: relative;
    overflow: hidden;
    padding: 60px;
  }

  .verify-phone-decorative-image {
    position: absolute;
    top: 0;
    right: 0;
    pointer-events: none;
  }

  .verify-phone-form {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .verify-phone-title {
    font-size: 32px;
    line-height: 36px;
    font-family: 'Rubik-Regular', sans-serif;
  }

  .verify-phone-subtitle {
    font-size: 16px;
    line-height: 20px;
  }

  .verify-phone-display {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .verify-phone-display-label {
    font-size: 14px;
    line-height: 18px;
    color: #6b7280;
  }

  .verify-phone-display-value {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    line-height: 20px;
  }

  .verify-phone-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .verify-phone-feedback {
    text-align: center;
  }
`
